import { render, staticRenderFns } from "./powerSchoolers.vue?vue&type=template&id=4652230f"
import script from "./powerSchoolers.vue?vue&type=script&lang=js"
export * from "./powerSchoolers.vue?vue&type=script&lang=js"
import style0 from "./powerSchoolers.vue?vue&type=style&index=0&id=4652230f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports